import { useSelector } from 'react-redux';
import { reducer } from './reducer';
import * as actions from './actionCreators';
import * as selectors from './selectors';
import { stateKeys } from './config';

const selectCanAddIndividualMeters = (state) =>
  state.authentication.userInfo?.CanEditIndividualMeters;

const useCanAddIndividualMeters = () => {
  const canAddIndividualMeters = useSelector(selectCanAddIndividualMeters);
  return canAddIndividualMeters;
};

export { reducer, actions, selectors, stateKeys, useCanAddIndividualMeters };
